<template>
    <div>
        <CCard>
            <CCardHeader>
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <strong>Автогенерация QR iiko Cards</strong>
                        <div class="small text-muted mt-1">
                            QR живёт на 1 день дольше периода генерации. Старый код отзывается в iiko через 1 день после отправки нового.
                            После создания нажмите «Сгенерировать» — дальше cron будет обновлять QR по расписанию.
                        </div>
                    </div>
                    <CButton
                        color="primary"
                        @click="openCreate">
                        Добавить
                    </CButton>
                </div>
            </CCardHeader>
            <CCardBody>
                <CDataTable
                    :items="schedules"
                    :fields="fields"
                    hover
                    striped
                    :loading="loading"
                    items-per-page="25"
                    pagination>
                    <template #enabled="{ item }">
                        <td>
                            <CBadge :color="item.enabled ? 'success' : 'secondary'">
                                {{ item.enabled ? 'Вкл' : 'Выкл' }}
                            </CBadge>
                        </td>
                    </template>
                    <template #schedule_type="{ item }">
                        <td>
                            {{ scheduleTypeLabel(item.schedule_type) }}
                            <div class="small text-muted">
                                жизнь {{ lifetimeDays(item.schedule_type) }} дн.
                            </div>
                        </td>
                    </template>
                    <template #category="{ item }">
                        <td>
                            {{ categoryLabel(item) }}
                        </td>
                    </template>
                    <template #emails="{ item }">
                        <td>
                            <div
                                v-for="(email, idx) in (item.emails || [])"
                                :key="`${item.id}-${idx}`">
                                {{ email }}
                            </div>
                        </td>
                    </template>
                    <template #next_generate_at="{ item }">
                        <td>{{ formatDate(item.next_generate_at) }}</td>
                    </template>
                    <template #last_generated_at="{ item }">
                        <td>{{ formatDate(item.last_generated_at) }}</td>
                    </template>
                    <template #actions="{ item }">
                        <td>
                            <div class="d-flex flex-wrap">
                                <CButton
                                    color="success"
                                    variant="outline"
                                    size="sm"
                                    class="mr-1 mb-1"
                                    :disabled="generatingId === item.id"
                                    @click="generateNow(item)">
                                    Сгенерировать
                                </CButton>
                                <CButton
                                    color="info"
                                    variant="outline"
                                    size="sm"
                                    class="mr-1 mb-1"
                                    @click="openHistory(item)">
                                    История
                                </CButton>
                                <CButton
                                    color="primary"
                                    variant="outline"
                                    size="sm"
                                    class="mr-1 mb-1"
                                    @click="openEdit(item)">
                                    Изменить
                                </CButton>
                                <CButton
                                    color="danger"
                                    variant="outline"
                                    size="sm"
                                    class="mb-1"
                                    @click="removeSchedule(item)">
                                    Удалить
                                </CButton>
                            </div>
                        </td>
                    </template>
                </CDataTable>
            </CCardBody>
        </CCard>

        <CModal
            :show.sync="formModal"
            :title="editingId ? 'Редактировать расписание QR' : 'Новое расписание QR'"
            size="lg"
            color="primary"
            @update:show="onFormModalToggle">
            <CForm>
                <CInput
                    v-model="form.title"
                    label="Название"
                    placeholder="Например, Кэпитал Ливинг"/>
                <CRow class="form-group">
                    <CCol
                        tag="label"
                        sm="3"
                        class="col-form-label">
                        Профиль iiko
                    </CCol>
                    <CCol sm="9">
                        <select
                            v-model.number="form.profile_id"
                            class="form-control"
                            @change="onProfileChange">
                            <option
                                v-for="profile in profiles"
                                :key="profile.id"
                                :value="profile.id">
                                {{ profile.title || profile.slug || `#${profile.id}` }}
                            </option>
                        </select>
                    </CCol>
                </CRow>
                <CRow class="form-group">
                    <CCol
                        tag="label"
                        sm="3"
                        class="col-form-label">
                        Категория
                    </CCol>
                    <CCol sm="9">
                        <select
                            v-model.number="form.category_id"
                            class="form-control">
                            <option :value="null">Выберите категорию</option>
                            <option
                                v-for="category in profileCategories"
                                :key="category.id"
                                :value="category.id">
                                {{ category.title || category.name }} ({{ category.iiko_category_id }})
                            </option>
                        </select>
                    </CCol>
                </CRow>
                <CInput
                    v-model="form.phone"
                    label="Телефон гостя в iiko"
                    placeholder="+79001234567"/>
                <CTextarea
                    v-model="form.emailsText"
                    label="Email для отправки"
                    rows="3"
                    placeholder="email1@example.com, email2@example.com"/>
                <CRow class="form-group">
                    <CCol
                        tag="label"
                        sm="3"
                        class="col-form-label">
                        Расписание
                    </CCol>
                    <CCol sm="9">
                        <select
                            v-model="form.schedule_type"
                            class="form-control">
                            <option value="daily">Раз в день (жизнь 2 дня)</option>
                            <option value="weekly">Раз в неделю (жизнь 8 дней)</option>
                            <option value="monthly">Раз в месяц (жизнь 31 день)</option>
                        </select>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol
                        tag="label"
                        sm="3"
                        class="col-form-label">
                        Активно
                    </CCol>
                    <CCol sm="9">
                        <CSwitch
                            :checked.sync="form.enabled"
                            color="success"
                            shape="pill"
                            variant="opposite"/>
                    </CCol>
                </CRow>
            </CForm>
            <template #footer>
                <CButton
                    color="secondary"
                    @click="formModal = false">
                    Отмена
                </CButton>
                <CButton
                    color="primary"
                    :disabled="saving"
                    @click="saveSchedule">
                    Сохранить
                </CButton>
            </template>
        </CModal>

        <CModal
            :show.sync="historyModal"
            :title="historyTitle"
            size="lg"
            color="info">
            <CDataTable
                :items="issues"
                :fields="issueFields"
                hover
                striped
                :loading="historyLoading"
                items-per-page="20"
                pagination>
                <template #status="{ item }">
                    <td>
                        <CBadge :color="issueStatusColor(item.status)">
                            {{ issueStatusLabel(item.status) }}
                        </CBadge>
                    </td>
                </template>
                <template #generated_at="{ item }">
                    <td>{{ formatDate(item.generated_at) }}</td>
                </template>
                <template #expires_at="{ item }">
                    <td>{{ formatDate(item.expires_at) }}</td>
                </template>
                <template #revoke_at="{ item }">
                    <td>{{ formatDate(item.revoke_at) }}</td>
                </template>
                <template #error_message="{ item }">
                    <td class="small text-danger">{{ item.error_message || '—' }}</td>
                </template>
            </CDataTable>
            <template #footer>
                <CButton
                    color="secondary"
                    @click="historyModal = false">
                    Закрыть
                </CButton>
            </template>
        </CModal>
    </div>
</template>

<script>
import Vue from 'vue';
import moment from 'moment';

const EMPTY_FORM = () => ({
    title: '',
    profile_id: 1,
    category_id: null,
    phone: '',
    emailsText: '',
    schedule_type: 'weekly',
    enabled: true,
});

export default {
    name: 'IikoCardQrScheduleSettings',

    data() {
        return {
            loading: false,
            saving: false,
            generatingId: null,
            schedules: [],
            profiles: [],
            categories: [],
            formModal: false,
            historyModal: false,
            historyLoading: false,
            historyTitle: 'История QR',
            editingId: null,
            issues: [],
            form: EMPTY_FORM(),
            fields: [
                { key: 'id', label: 'ID', _style: 'width:60px;' },
                { key: 'title', label: 'Название' },
                { key: 'enabled', label: 'Статус', _style: 'width:80px;' },
                { key: 'schedule_type', label: 'Расписание' },
                { key: 'phone', label: 'Телефон' },
                { key: 'category', label: 'Категория' },
                { key: 'emails', label: 'Email' },
                { key: 'last_generated_at', label: 'Последняя генерация' },
                { key: 'next_generate_at', label: 'Следующая генерация' },
                { key: 'actions', label: 'Действия', _style: 'width:280px;', sorter: false, filter: false },
            ],
            issueFields: [
                { key: 'id', label: 'ID', _style: 'width:60px;' },
                { key: 'status', label: 'Статус' },
                { key: 'card_track', label: 'Track' },
                { key: 'card_number', label: 'Номер' },
                { key: 'generated_at', label: 'Создан' },
                { key: 'expires_at', label: 'Истекает' },
                { key: 'revoke_at', label: 'Отзыв' },
                { key: 'error_message', label: 'Ошибка' },
            ],
        };
    },

    computed: {
        profileCategories() {
            return (this.categories || []).filter(
                category => Number(category.profile_id) === Number(this.form.profile_id)
            );
        },
    },

    async mounted() {
        await Promise.all([
            this.loadProfiles(),
            this.loadSchedules(),
        ]);
        if (this.profiles.length) {
            this.form.profile_id = this.profiles[0].id;
            await this.loadCategories(this.form.profile_id);
        }
    },

    methods: {
        scheduleTypeLabel(type) {
            return {
                daily: 'Раз в день',
                weekly: 'Раз в неделю',
                monthly: 'Раз в месяц',
            }[type] || type;
        },
        lifetimeDays(type) {
            return {
                daily: 2,
                weekly: 8,
                monthly: 31,
            }[type] || '—';
        },
        categoryLabel(item) {
            const category = item.category;
            if (!category) return `#${item.category_id}`;
            return category.title || category.name || `#${category.id}`;
        },
        formatDate(value) {
            if (!value) return '—';
            return moment(value).format('DD.MM.YYYY HH:mm');
        },
        issueStatusLabel(status) {
            return {
                active: 'Активен',
                pending_revoke: 'Ожидает отзыва',
                revoked: 'Отозван',
                failed: 'Ошибка',
            }[status] || status;
        },
        issueStatusColor(status) {
            return {
                active: 'success',
                pending_revoke: 'warning',
                revoked: 'secondary',
                failed: 'danger',
            }[status] || 'secondary';
        },
        parseEmails(text) {
            return String(text || '')
                .split(/[,;\s]+/)
                .map(email => email.trim())
                .filter(Boolean);
        },
        async loadProfiles() {
            const { data } = await Vue.axios.get('/iiko-card/profiles');
            this.profiles = data || [];
        },
        async loadCategories(profileId) {
            const { data } = await Vue.axios.get('/iiko-card/categories', {
                params: { profile_id: profileId },
            });
            this.categories = data || [];
        },
        async loadSchedules() {
            this.loading = true;
            try {
                const { data } = await Vue.axios.get('/iiko-card-qr-schedule');
                this.schedules = data || [];
            } catch (error) {
                this.$root.$emit('showError', error?.response?.data?.error || 'Ошибка загрузки расписаний');
            }
            this.loading = false;
        },
        async onProfileChange() {
            this.form.category_id = null;
            await this.loadCategories(this.form.profile_id);
        },
        openCreate() {
            this.editingId = null;
            this.form = EMPTY_FORM();
            this.form.profile_id = this.profiles[0]?.id || 1;
            this.loadCategories(this.form.profile_id);
            this.formModal = true;
        },
        async openEdit(item) {
            this.editingId = item.id;
            this.form = {
                title: item.title || '',
                profile_id: item.profile_id,
                category_id: item.category_id,
                phone: item.phone || '',
                emailsText: (item.emails || []).join(', '),
                schedule_type: item.schedule_type || 'weekly',
                enabled: !!item.enabled,
            };
            await this.loadCategories(this.form.profile_id);
            this.formModal = true;
        },
        onFormModalToggle(show) {
            if (!show) {
                this.editingId = null;
                this.form = EMPTY_FORM();
            }
        },
        async saveSchedule() {
            const emails = this.parseEmails(this.form.emailsText);
            if (!this.form.title || !this.form.phone || !this.form.category_id || !emails.length) {
                this.$root.$emit('showError', 'Заполните название, телефон, категорию и email');
                return;
            }

            this.saving = true;
            const payload = {
                title: this.form.title,
                profile_id: this.form.profile_id,
                category_id: this.form.category_id,
                phone: this.form.phone,
                emails,
                schedule_type: this.form.schedule_type,
                enabled: !!this.form.enabled,
            };

            try {
                if (this.editingId) {
                    await Vue.axios.put(`/iiko-card-qr-schedule/${this.editingId}`, payload);
                    this.$root.$emit('showSuccess', 'Расписание обновлено');
                } else {
                    await Vue.axios.post('/iiko-card-qr-schedule', payload);
                    this.$root.$emit('showSuccess', 'Расписание создано');
                }
                this.formModal = false;
                await this.loadSchedules();
            } catch (error) {
                this.$root.$emit('showError', error?.response?.data?.error || 'Ошибка сохранения');
            }
            this.saving = false;
        },
        async generateNow(item) {
            const confirmed = confirm(`Сгенерировать и отправить QR для «${item.title}» сейчас?`);
            if (!confirmed) return;

            this.generatingId = item.id;
            try {
                await Vue.axios.post(`/iiko-card-qr-schedule/${item.id}/generate`);
                this.$root.$emit('showSuccess', 'QR сгенерирован и отправлен');
                await this.loadSchedules();
            } catch (error) {
                this.$root.$emit('showError', error?.response?.data?.error || 'Ошибка генерации QR');
            }
            this.generatingId = null;
        },
        async openHistory(item) {
            this.historyTitle = `История QR — ${item.title}`;
            this.historyModal = true;
            this.historyLoading = true;
            try {
                const { data } = await Vue.axios.get(`/iiko-card-qr-schedule/${item.id}/issues`);
                this.issues = data || [];
            } catch (error) {
                this.$root.$emit('showError', error?.response?.data?.error || 'Ошибка загрузки истории');
                this.issues = [];
            }
            this.historyLoading = false;
        },
        async removeSchedule(item) {
            const confirmed = confirm(`Удалить расписание «${item.title}»? История выпусков тоже будет удалена.`);
            if (!confirmed) return;

            try {
                await Vue.axios.delete(`/iiko-card-qr-schedule/${item.id}`);
                this.$root.$emit('showSuccess', 'Расписание удалено');
                await this.loadSchedules();
            } catch (error) {
                this.$root.$emit('showError', error?.response?.data?.error || 'Ошибка удаления');
            }
        },
    },
};
</script>
